import { BATCH_TYPE, BatchDetailModel } from '@components/Sales/type'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useOpenComparisonModal } from '@context/BatchPlusContext/BatchPlusContext'
import PaymentModal from '@components/Sales/PaymentModal/PaymentModal'
import MahapackPlanModal from '@components/Sales/MahapackModal/MahapackPlanModal'
import BatchUserModal from '@components/Sales/BatchUserModal/BatchUserModal'
import InstalmentModal from '@components/Sales/InstallmentModal/InstallmentModal'
import UserRegistrationModal from '@components/Sales/UserRegistrationModal/UserRegistrationModal'

export enum IFrameActions {
  PARENT_NAVIAGTION = 'PARENT_NAVIAGTION',
  ABSOLUTE_ZERO = 'ABSOLUTE_ZERO',
  AFTER_PAYMENT_BACK = 'AFTER_PAYMENT_BACK',
  BACK_PW_SCHOLAR = 'BACK_PW_SCHOLAR',
  PLAN_BUY_NOW_CLICK = 'PLAN_BUY_NOW_CLICK',
  AMBASSADOR_BUY = 'AMBASSADOR_BUY',
  OPEN_COMPARISON_TABLE = 'OPEN_COMPARISON_TABLE',
  GO_BACK = 'GO_BACK',
  URL_REDIRECTION = 'URL_REDIRECTION',
  AMBASSADOR_COHORT_SELECTION = 'AMBASSADOR_COHORT_SELECTION',
  CSC_FORM_SUBMISSION = 'CSC_FORM_SUBMISSION',
}

export enum ApplicationTypes {
  PAYMENT_FE = 'PAYMENT_FE',
  BATCH_PLUS_TABLE = 'BATCH_PLUS_TABLE',
  LEAD_FORM = 'LEAD_FORM',
  PAYMENT_MF = 'PAYMENT_MF',
}

export interface IFrameMessageProps {
  action: IFrameActions
  value: string
  batchDetails: string
  applicationType: ApplicationTypes
  payload?: any
}

//TODO: add all the origins where we are going to send and receive message between parent and child iframe
//TODO: move this to parent app i.e angular
export const ALLOWED_ORIGINS: Readonly<string[]> = Object.freeze([
  'www.pw.live',
])

/**
 * If the application is rendered through an IFrame by a parent application
 * then we are listening for messages from the parent and handling routing.
 */
export const RoutingListner = () => {
  // const router = useRouter()
  const navigate = useNavigate()
  const [particularBatchDetails, setParticularBatchDetails] = useState({})
  const [isVPLiveModalOpen, setIsVPLiveModalOpen] = useState(false)
  const [batchType, setBatchType] = useState('')
  const [selectedPlan, setSelectedPlan] = useState<any>({})
  const [isUserModalOpen, setUserModalOpen] = useState(false)
  const [paymentModeSelected, setPaymentModeSelected] = useState('installments')
  const [isMahapackModalOpen, setIsMahapackModalOpen] = useState(false)
  const [isInstallmentModalOpen, setInstallmentModalOpen] = useState(false)
  const [isUserRegisterModalOpen, setIsUserRegisterModalOpen] = useState(false)
  const [enteredUserData, setEnteredData] = useState()

  const { openComparisonTable } = useOpenComparisonModal()

  function submitCSCForm({ url, message }: { url: string; message: string }) {
    // Create a form element
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = url
    form.target = '_self' // opens in the same tab
    // Add the hidden message field
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = 'message'
    input.value = message
    form.appendChild(input)
    document.body.appendChild(form)
    // Auto-submit
    form.submit()
    // Cleanup
    document.body.removeChild(form)
  }

  const handlePowerPaymentClose = (plan: any, mode: string) => {
    setIsVPLiveModalOpen(false)
    setUserModalOpen(true)
    setSelectedPlan(plan)
    setPaymentModeSelected(mode)
  }
  const handleInstallmentOpen = (plan: any, mode: string) => {
    setIsVPLiveModalOpen(false)
    setInstallmentModalOpen(true)
    setSelectedPlan(plan)
    setPaymentModeSelected(mode)
  }
  const handleMahapackPaymentClose = (plan: any) => {
    setIsMahapackModalOpen(false)
    setUserModalOpen(true)
    setSelectedPlan(plan)
    setPaymentModeSelected('normal')
  }

  const handleInstallmentClose = () => {
    setIsVPLiveModalOpen(true)
    setInstallmentModalOpen(false)
  }

  const handleBuy = (batchDetails: BatchDetailModel) => {
    localStorage.setItem('BATCH_DETAILS', JSON.stringify(batchDetails))
    if (
      batchDetails?.notifyMeStatus === 'ALREADY_REGISTERED' ||
      batchDetails?.isPurchased
    ) {
      return
    }

    if (!!batchDetails?.masterBatchId) {
      setParticularBatchDetails(batchDetails)
      setSelectedPlan({
        batchId: batchDetails?._id,
        _id: '',
        total: batchDetails?.fee?.total || 0,
        title: batchDetails?.name,
      })
      setUserModalOpen(true)
      setBatchType('normal')
    } else if (
      !batchDetails?.isBatchPlusEnabled &&
      batchDetails?.type !== BATCH_TYPE.MAHAPACK
    ) {
      setSelectedPlan({
        batchId: batchDetails?._id,
        _id: '',
        total: batchDetails?.fee?.total || 0,
        title: batchDetails?.name,
      })
      setUserModalOpen(true)
      setPaymentModeSelected('normal')
      setBatchType('normal')
    } else if (batchDetails?.type === BATCH_TYPE.MAHAPACK) {
      if (batchDetails?.isPlanEnabled) {
        setParticularBatchDetails(batchDetails)
        setIsMahapackModalOpen(true)
      } else {
        setSelectedPlan({
          batchId: batchDetails?._id,
          _id: '',
          total: batchDetails?.fee?.total || 0,
          title: batchDetails?.name,
        })
        setUserModalOpen(true)
        setPaymentModeSelected('normal')
      }
      setBatchType('mahapack')
    } else if (batchDetails?.isBatchPlusEnabled) {
      const payload = {
        batchDetails: batchDetails,
        source: 'batch_listing',
        sourceCTA: 'purchase-alert',
      }
      setBatchType('batch_plus')
      openComparisonTable({
        batchName: batchDetails?.name,
        batchId: batchDetails?._id,
        popupCtaName: 'buy_now',
        pageName: 'batch_listing',
      })

      return
    }
  }

  const handleBatchUserModal = (registerUserData: any) => {
    setUserModalOpen(false)
    setEnteredData(registerUserData)
    setIsUserRegisterModalOpen(true)
  }

  useEffect(() => {
    const handleMessageFromParent = (
      event: MessageEvent<IFrameMessageProps>
    ) => {
      if (
        event.data.action === IFrameActions.PARENT_NAVIAGTION &&
        event.data.applicationType === ApplicationTypes.PAYMENT_FE
      ) {
        const cohortId = localStorage?.getItem('COHORT_ID') || ''
        navigate(`/sales/batch-listing?cohortId=${cohortId}`)
      }
      if (
        event.data.action === IFrameActions.AMBASSADOR_BUY &&
        event.data.applicationType === ApplicationTypes.PAYMENT_FE
      ) {
        const batchDetails = JSON.parse(event.data.batchDetails)
        handleBuy(batchDetails)
        // const cohortId = localStorage?.getItem("COHORT_ID") || ""
        // navigate(`/sales/order-summary`)
      }

      if (
        event.data.action === IFrameActions.AMBASSADOR_COHORT_SELECTION &&
        event.data.applicationType === ApplicationTypes.PAYMENT_FE
      ) {
        navigate(`/cohort-selection`)
      }

      if (
        event.data.action === IFrameActions.OPEN_COMPARISON_TABLE &&
        event.data.applicationType === ApplicationTypes.BATCH_PLUS_TABLE
      ) {
        const batchDetails: any = JSON.parse(
          localStorage.getItem('BATCH_DETAILS') || '{}'
        )
        openComparisonTable({
          batchName: batchDetails?.name,
          batchId: batchDetails?._id,
          popupCtaName: 'buy_now',
          pageName: 'order_summary',
        })
      }
      if (
        event.data.action === IFrameActions.GO_BACK &&
        event.data.applicationType === ApplicationTypes.PAYMENT_MF
      ) {
        const cohortId = localStorage?.getItem('COHORT_ID') || ''
        navigate(`/sales/batch-listing?cohortId=${cohortId}`)
      }
      if (
        event.data.action === IFrameActions.URL_REDIRECTION &&
        event.data.applicationType === ApplicationTypes.PAYMENT_MF
      ) {
        window.location.href = event?.data?.payload?.url || ''
      }
      if (
        event.data.action === IFrameActions.CSC_FORM_SUBMISSION &&
        (event.data.applicationType === ApplicationTypes.PAYMENT_MF ||
          event.data.applicationType === ApplicationTypes.PAYMENT_FE)
      ) {
        submitCSCForm({
          url: event?.data?.payload?.url || '',
          message: event?.data?.payload?.message || '',
        })
      }
      // Navigate to new route if action from parent is Navigation
    }

    window.addEventListener('message', handleMessageFromParent)
    return () => window.removeEventListener('message', handleMessageFromParent)
  }, [])

  return (
    <>
      {isVPLiveModalOpen && (
        <PaymentModal
          isOpen={isVPLiveModalOpen}
          onClose={() => setIsVPLiveModalOpen(false)}
          handlePowerPaymentClose={handlePowerPaymentClose}
          batchDetails={particularBatchDetails}
          handleInstallmentOpen={handleInstallmentOpen}
        />
      )}
      {isMahapackModalOpen && (
        <MahapackPlanModal
          isOpen={isMahapackModalOpen}
          onClose={() => {
            setIsMahapackModalOpen(false)
          }}
          batchDetails={particularBatchDetails}
          handleMahapackPaymentClose={handleMahapackPaymentClose}
        />
      )}
      {isUserModalOpen && (
        <BatchUserModal
          isOpen={isUserModalOpen}
          onClose={() => {
            setUserModalOpen(false)
          }}
          selectedPlan={selectedPlan}
          partPayment={paymentModeSelected === 'installments'}
          batchType={batchType}
          handleBatchUserModal={handleBatchUserModal}
        />
      )}
      {isUserRegisterModalOpen && (
        <UserRegistrationModal
          isOpen={isUserRegisterModalOpen}
          onClose={() => setIsUserRegisterModalOpen(false)}
          enteredUserData={enteredUserData}
          selectedPlan={selectedPlan}
        />
      )}
      {isInstallmentModalOpen && (
        <InstalmentModal
          isOpen={isInstallmentModalOpen}
          onClose={handleInstallmentClose}
          selectedPlan={selectedPlan}
        />
      )}
    </>
  )
}
